import { ZoneTypeName } from '@/pages/Business/pages/LogisticOperator/models';

const normalize = (name: string): string =>
  name
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '');

const ROUTING_TYPE_NORMALIZED = new Set(
  [ZoneTypeName.ROUTING, 'routing', 'routingZone', 'ruteo', 'routingzone'].map(
    normalize
  )
);

export function isRoutingZoneTypeName(name: string): boolean {
  return ROUTING_TYPE_NORMALIZED.has(normalize(name));
}

export function getEnvRoutingZoneTypeId(): string | null {
  const v = import.meta.env.VITE_ROUTING_ZONE_TYPE_ID;
  if (typeof v !== 'string') {
    return null;
  }
  const t = v.trim();
  if (t === '') {
    return null;
  }
  return t;
}

export function resolveRoutingZoneTypeId(
  items: ReadonlyArray<{ id: string; name: string }>
): string | null {
  const fromEnv = getEnvRoutingZoneTypeId();
  if (fromEnv !== null) {
    return fromEnv;
  }

  for (const t of items) {
    if (ROUTING_TYPE_NORMALIZED.has(normalize(t.name))) {
      return t.id;
    }
  }
  return null;
}
